<template>
  <div>
    <div v-for="(group, groupIndex) in agenda.groups" :key="`agenda-group-${groupIndex}`">
      <h5 class="session-day">{{group.date}}</h5>

      <div v-for="(session, sessionIndex) in group.sessions" :class="`card ${session.group_id}`" :key="`agenda-session-${sessionIndex}`">
        <div class="card-header agenda-group-header-wrapper">
          {{session.name}} {{session.start_at}} - {{session.end_at}}
        </div>

        <div class="">
          <form class="agenda-groups-form">
            <ul>
              <li
                v-for="(el, elIndex) in session.items"
                class="agenda-session-item"
                :class="isCapacityReached(el) ? 'capacity-reached' : ''"
              >
                <validation-provider
                  class="session-room-checkbox-wrapper"
                  :vid="`sessions.${elIndex}.selected`"
                  v-slot="{errors}"
                >
                  <event-radio
                    :class="{'is-invalid': errors && errors[0]}"
                    :label="showSessionLabel(el)"
                    v-model="session.selected"
                    :name="session.group_id"
                    :data-value="el.id"
                    :disabled="isCapacityReached(el)"
                  ></event-radio>
                  <span v-if="errors && errors[0]" class="input-error text-danger">{{errors[0]}}</span>
                </validation-provider>

                <p>
                  <strong>Start Date:</strong> <span class="font-weight-normal">{{el.date}}</span>
                  <strong> | Start Time:</strong> <span class="font-weight-normal">{{el.start_at}}</span>
                  <strong> | End Time:</strong> <span class="font-weight-normal">{{el.end_at}}</span>
                </p>

                <p v-if="el.speakers?.length">
                  <strong>Speakers:</strong>
                  <span
                    v-for="(speaker, speakerIndex) in el.speakers" :key="`session-${session.id}-speaker-${speakerIndex}`"
                    class="font-weight-normal"
                  >
                          {{speaker.name}}<span v-show="(speakerIndex + 1) < el?.speakers?.length">, </span>
                        </span>
                </p>

                <p class="font-weight-normal" v-show="el.description" v-html="el.description"></p>

                <hr v-show="(elIndex + 1) < session.items?.length" />
              </li>
            </ul>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    agenda: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  methods: {
    isCapacityReached(el) {
      if (this.agenda.concurrent_session && el.available_capacity <= 0) {
        return true;
      }
      return false;
    },

    showSessionLabel(el) {
      let label = el.name;
      if (this.agenda.concurrent_session && el.count_capacity) {
        let helpText;
        if (el.available_capacity > 0) {
          helpText = `<span>${el.available_capacity} spots remaining</span>`;
        } else {
          helpText = `<span class="text-danger">Capacity Reached</span>`;
        }

        label = `${label} - ${helpText}`;
      }
      return label;
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group .control-label {
  font-weight: 400;
}

::v-deep .app-checkbox div {
  font-weight: 400;
}

::v-deep .fv-help-block {
  font-family: sans-serif;
  font-weight: 700;
  color: #dc3545 !important;
  font-size: 16px;
}
</style>
